import React from "react";
import { amenitiesData } from "../../data";

const Booking = () => {
  return (
    <section className="pt-6 pb-12">
      <div className="container mx-auto">
        <h2 className="text-[22px] md:text-3xl font-semibold mb-6">
          Included with every stay
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-center">
          {amenitiesData.map((data, index) => (
            <div key={index} className="bg-[#fff] rounded-xl px-4 lg:px-6 py-6">
              <div className="flex flex-col md:flex-row justify-between items-center space-y-2">
                <div className="mb-4 border-icon-service">
                  <img
                    src={data.icon}
                    alt={data.title}
                    className="flex-shrink-0 h-[36px] max-h-[36px]"
                  />
                </div>
                <div className="flex flex-col">
                  <p className="font-semibold ml-[2px]">{data.title}</p>
                  {data.comingSoon && <span className="text-[12px] text-red-500">Coming Soon</span>}
                </div>
              </div>
              <p className="text-[14px] text-center md:text-left mt-2">
                {data.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Booking;
